module.exports = __webpack_public_path__ + "img/ico_change.9294b30e.svg";